import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {AuthModel} from '../models/auth.model';
import {catchError, switchMap} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this.authService.getAuthFromLocalStorage();
    let r = req;
    if (auth) {
      r = req.clone({
        headers: applyTokensToHeaders(req, auth)
      });
    }
    return next.handle(r).pipe(
      catchError((err) => this.handleError(err, req, next))
    );
  }


  handleError(error: HttpErrorResponse, req?, next?): Observable<any> {
    if (error.status === 401) {
      return this.authService.refreshUser().pipe(
        switchMap(() => {
          const auth = this.authService.getAuthFromLocalStorage();
          const r = req.clone({
            headers: applyTokensToHeaders(req, auth)
          });
          return next.handle(r);
        }),
        catchError((err) => {
          this.authService.logout();
          throw err;
        })
      );
    } else {
      throw error;
    }
  }
}


function applyTokensToHeaders(req: HttpRequest<any>, tokens: AuthModel): HttpHeaders {
  let headers = req.headers;
  if (tokens) {
    headers = tokens.accessToken ? headers.set('authorization', tokens.accessToken) : headers;
    headers = tokens.refreshToken ? headers.set('refresh-token', tokens.refreshToken) : headers;
  }
  return headers;
}
